import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
const PDPGalleryLabelsUI = t0 => {
  const $ = _c(8);
  const {
    labels: t1,
    loading: t2,
    color
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const labels = t3;
  const loading = t2 === undefined ? false : t2;
  let t4;
  if ($[2] !== color || $[3] !== labels || $[4] !== loading) {
    t4 = !loading && labels.map(label => <div className={classNames("text-xs font-bold items-center rounded text-gray flex justify-center h-[25px] ml-2 pl-3 pr-3 first:ml-0 w-max", {
      "bg-yellow-light": color !== "orange",
      "bg-orange": color === "orange"
    })} key={label}>{label}</div>);
    $[2] = color;
    $[3] = labels;
    $[4] = loading;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="flex">{t4}</div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
PDPGalleryLabelsUI.propTypes = {
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  loading: PropTypes.bool
};
export default PDPGalleryLabelsUI;